import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function SortIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M10.6318 10.4043L8 7.55591V21H6V7.55591L3.36816 10.4043L1.89941 9.04688L7 3.52637L12.1006 9.04688L10.6318 10.4043ZM20.6318 14.5957L18 17.4441V4H16V17.4441L13.3682 14.5957L11.8994 15.9531L17 21.4736L22.1006 15.9531L20.6318 14.5957V14.5957Z",
    fill: "currentColor"
  }));
}